import React from "react";
import { TabContent, TabPane } from "reactstrap";
import { JsBehaviorListData } from "../../../../Data/UiKits/Lists";
import { SimpleTabContentProp } from "../../../../Types/UiKitsType";

const JsBehaviorContent: React.FC<SimpleTabContentProp> = ({ tabId }) => {
  return (
    <TabContent activeTab={tabId}>
      {JsBehaviorListData &&
        JsBehaviorListData.map((item, index) => (
          <TabPane className={`${item.class} ${tabId === item.id ? "show" : ""}`} tabId={item.id} key={index}>
            {item.htmlText}
          </TabPane>
        ))}
    </TabContent>
  );
};
export default JsBehaviorContent;
